import '@/styles/main.css';
import { initPostHog } from './src/lib/posthog'
import { trackHubSpotRouteUpdate } from './src/lib/hubspot'

export const onClientEntry = () => {
  initPostHog()
}

export const onRouteUpdate = (args) => {
  trackHubSpotRouteUpdate(args)
}
